import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFavorites } from '../../hooks/useFavorites';
import BestList from '../../components/List/bestList';
import Loading from '../../components/Common-components/loading';
import { useUser } from '../../contexts/UserContext';
import '../../css/List/bookmarkList.css';

export default function BookMarkList() {
  const navigate = useNavigate();
  const { user, loading } = useUser();
  const { favorites, favoritesLoading } = useFavorites();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
    }
  }, [loading, user, navigate]);

  if (loading || favoritesLoading) {
    return <Loading isLoading={true} />;
  }

  if (!user) {
    return null;
  }

  if (!favorites || favorites.length === 0) {
    return (
      <section className="no-bookmark-data">
        <div className="no-bookmark-data-wrapper">
          <h2 className='title'>찜한 여행</h2>

          <div className='no-bookmark-info'>
            <p className='info-title'>아직 찜한 여행이 없어요.</p>
            <p className='info-content'>마음에 드는 여행을 저장할려면 '찜하기' 버튼을 클릭하세요.</p>
            <button type='button' className='btn go-home-btn' onClick={() => {navigate('/')}}>홈으로</button>
          </div>
        </div>
      </section>
    );
  }

  return <BestList listData={favorites} pageTitle="찜한 여행" />;
}
